<div class="modal-header">
      <h5 class="modal-title">Confirmation</h5>
    </div>
    <div class="modal-body">
      <p>{{qmessage}}</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" (click)="continue()">Continue</button>
      <button class="btn btn-secondary" (click)="recheck()">Recheck</button>
</div>